import { defineEffect } from '../../../core/effect';

/**
 * **ダメージステップの終わり**（Issue #535）。舞台の設定を素に戻すだけ。
 *
 * **戻すのは消す側の仕事**（設計文書 §6.1）—— 演出は帯が外れたらもう呼ばれないので、
 * 自分では戻せない（`ObjectLayer` の「借りたものは器が素に戻す」と同じ形）。
 */
export default defineEffect({
  situation: 'damage_step_end',
  label: 'ダメージステップ終了',
  scene: 'reset',
}, 'damage_step_end_effect.js');
